import './feedbackComponent.scss'
import React from 'react';
import {Alert} from "@mui/material";

interface FeedbackComponentProps {
    type?: 'error' | 'info' | 'success' | 'warning';
    color?: 'error' | 'info' | 'success' | 'warning' | undefined;
    variant?: 'filled' | 'outlined' | 'standard' | undefined;
    icon?: React.ReactNode;
    closeText?: string;
    className?: string;
}

const FeedbackComponent = (props: React.PropsWithChildren<FeedbackComponentProps>) => {

    const {children} = props;
    let {closeText, variant, color, icon, type, className} = props;
    if (!type) type = "info";
    if (!color) color = "info";
    if (!variant) variant = "standard";
    if (!icon) icon = false;

    return (
        <div className={'feedback-component-wrapper'}>
            <Alert severity={type} className={className} color={color} variant={variant} icon={icon}
                   closeText={closeText}>
                {children}
            </Alert>
        </div>
    )
};

export default FeedbackComponent;